import styled from 'styled-components';

export const Wrap = styled.div`
  padding: 16px 24px 0px 24px;
`;

export const Title = styled.div`
  padding-bottom: 12px;
  ${({ theme }) => theme.textStyles.heading03global02};
`;

export default null;



// WEBPACK FOOTER //
// /opt/build/repo/src/modules/main/components/PresetSwitcher/PresetSwitcher.styled.js